module.exports = __webpack_public_path__ + "img/saint-kitts-and-nevis.ffaadad7.png";